// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"bdb9da72","349":"80f23c8a","390":"2d1f4e9c","400":"be928896","417":"92c1f518","453":"a22e05e0","504":"6c460d81","653":"3dcef79f","840":"da5f1106","932":"349be8fe"}[chunkId] + ".chunk.js";
};